(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-rev-slider')) {
    customElements.define('mc-rev-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.mc-rev__track');
        this.cards = Array.from(this.track.children);
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');
        this.bar = this.querySelector('.mc-rev__bar span');
        this.querySelectorAll('.mc-rev__arrow').forEach((b) => b.addEventListener('click', () => { this.stop(); this.go(Number(b.dataset.dir)); }));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); this.stop(); this.go(1); } if (e.key === 'ArrowLeft') { e.preventDefault(); this.stop(); this.go(-1); } });
        ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => this.track.addEventListener(ev, () => this.stop(), { passive: true }));
        window.addEventListener('resize', () => this.update());
        this.update();
        const s = Number(this.dataset.autoplay || 0);
        if (s > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.timer = setInterval(() => { if (!this.matches(':hover') && !this.contains(document.activeElement)) this.go(1, true); }, s * 1000);
        }
      }
      disconnectedCallback() { this.stop(); }
      stop() { clearInterval(this.timer); this.timer = null; }
      step() { return this.cards.length > 1 ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : this.track.clientWidth; }
      index() { return Math.round(this.track.scrollLeft / this.step()); }
      atEnd() { return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2; }
      go(dir, loop) {
        if (loop && dir > 0 && this.atEnd()) { this.track.scrollTo({ left: 0 }); return; }
        this.track.scrollTo({ left: Math.max(0, (this.index() + dir) * this.step()) });
      }
      update() {
        const sichtbar = Math.max(1, Math.round(this.track.clientWidth / this.step()));
        const t = this.track;
        if (this.bar && t.scrollWidth > 0) { this.bar.style.setProperty('--mc-rev-w', (t.clientWidth / t.scrollWidth * 100) + '%'); this.bar.style.setProperty('--mc-rev-l', (t.scrollLeft / t.scrollWidth * 100) + '%'); }
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.atEnd();
        const nav = this.querySelector('.mc-rev__nav');
        if (nav) nav.hidden = this.cards.length <= sichtbar;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
